import { Button } from "basis";
import { STATIC_RESOURCES } from "constants/contacts";
import { useProfile } from "library/hooks/auth/useProfile";
import { setTnCString } from "library/validator";
import { usePageTracking } from "react-event-tracker";
import { useLocation, useNavigate } from "react-router-dom";
import { SvgInline } from "../SvgInline/SvgInline";
import styles from "./terms-and-conditions.module.scss";
import { LocationWithReferer } from "./types";

const { tncPdfAu } = STATIC_RESOURCES;
const { tncPdfNz } = STATIC_RESOURCES;

export const TermsAndConditions = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const location = useLocation() as LocationWithReferer;
  const pathname = location?.state?.referer?.pathname || "/";
  const referer = pathname !== "/terms" ? pathname : "/";

  usePageTracking({
    page: {
      pageType: "confirmation-page",
      siteSection: "login",
      siteSubSection: "",
      pageTitle: "termsAndConditions",
    },
    user: {
      authenticationStatus: "logged in",
    },
  });

  return (
    <div className={`${styles.wrapper} ${styles.staticDetails}`}>
      <div className={styles.panel}>
        <section>
          <h1 className={`h4 ${styles.h4}`}>Terms and Conditions</h1>
          <p className={styles.desktopContent}>
            We have updated the Terms and Conditions for the Latitude Service
            Centre. View the links below to learn more.
          </p>
          <div className={styles.links}>
            <a href={tncPdfAu} target="_blank" rel="noopener noreferrer">
              Australian Latitude Service Centre Terms and Conditions
            </a>
            <a href={tncPdfAu} target="_blank" rel="noopener noreferrer">
              <SvgInline name="icon-download" className={styles.download} />
            </a>
          </div>
          <hr className={styles.hrdotted} />
          <div className={styles.links}>
            <a href={tncPdfNz} target="_blank" rel="noopener noreferrer">
              New Zealand Latitude Service Centre Terms and Conditions
            </a>
            <a href={tncPdfNz} target="_blank" rel="noopener noreferrer">
              <SvgInline name="icon-download" className={styles.download} />
            </a>
          </div>
          <Button
            margin="10 0 0 0"
            width="160"
            onClick={() => {
              setTnCString(profile?.id);
              navigate(referer);
            }}
          >
            I agree
          </Button>
        </section>
      </div>
    </div>
  );
};
